import {createSlice} from "@reduxjs/toolkit";

export interface IServerCacheState {
    isDisabled: boolean;
}

const initialState: IServerCacheState = {
    isDisabled: false
};

export const serverCacheSlice = createSlice({
    name: "serverCache",
    initialState,
    reducers: {
        disableServerCache: (state) => {
            state.isDisabled = true;
        }
    }
});

export const {disableServerCache} = serverCacheSlice.actions;
import {createSlice} from "@reduxjs/toolkit";

export interface IServerCacheState {
    isDisabled: boolean;
}

const initialState: IServerCacheState = {
    isDisabled: false
};

export const serverCacheSlice = createSlice({
    name: "serverCache",
    initialState,
    reducers: {
        disableServerCache: (state) => {
            state.isDisabled = true;
        }
    }
});

export const {disableServerCache} = serverCacheSlice.actions;
